import { useMemo } from 'react'
import { useInterval, useMap } from 'ahooks'

import { dayjs } from '@/lib/dayjs.ts'
import { Document } from '@/features/documents/types.ts'

export function useDocumentProcessingStatus(
  documents: Array<Document> | undefined,
  processingStatusVisible: boolean
) {
  const [elapsedSecondsMap, elapsedSecondsMapCtrl] = useMap<string, number>()
  const areThereProcessingDocuments = useMemo(
    () => documents?.find((document) => document.status === 'processing'),
    [documents]
  )
  useInterval(
    () => {
      documents?.forEach((document) => {
        const startTime = document.processing_at
        const endTime = document.in_review_at ?? new Date()

        if (startTime) {
          elapsedSecondsMapCtrl.set(
            document.id,
            dayjs(endTime).diff(startTime, 'seconds')
          )
        }
      })
    },
    processingStatusVisible && areThereProcessingDocuments ? 1000 : undefined
  )

  return { elapsedSecondsMap }
}
